module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/wirecard-75e1c23290fb794e20be29dd6272460e.png";